import type { FC, PropsWithChildren } from 'react';

import { useZustand } from '../../zustandStore';

import { DialogActionsButton } from './commonComponents';

export const ManagementActions: FC<PropsWithChildren> = () => {
	const { setIsCookieCutterOpen, setShowManageCookies, saveConsent } = useZustand(state => ({ ...state }));

	const handleSave = () => {
		saveConsent();
		setShowManageCookies(false);
		setIsCookieCutterOpen(false);
	};

	return (
		<DialogActionsButton
			variant="outlined"
			color="primary"
			onClick={handleSave}
			style={{ justifyContent: 'center' }}
			data-testid="save-cookies-settings"
		>
			Save cookie settings
		</DialogActionsButton>
	);
};
